export default __webpack_public_path__ + "static/media/error_bg.b23ffe02.png";